export default __webpack_public_path__ + "media/images/images_v2/bordure2-ca465adc22722d6f9c1f9de6c0710a72.png";